import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import RolePermissionName from "../../components/rolePermission/RolePermissionDetail/RolePermissionName.tsx";
import {useLocationFormState} from "../../components/rolePermission/RolePermissionForm/RolePermissionUpdateForm";
import RolePermissionUpdateFormProvider from "../../components/rolePermission/RolePermissionForm/RolePermissionUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RolePermissionUpdateEditPage = () => {
    
    useTitle(t`Update Role Permission`);

    const { rolePermissionId: id } = useParams();
    
    return (
        <Box data-testid="RolePermission-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="RolePermission-update-title"
                    >
                        <Trans>Edit Role Permission</Trans>:  <RolePermissionName id={id}/>
                    </Typography>
                    <RolePermissionUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default RolePermissionUpdateEditPage;
